<!--  -->
<template>
  <div class="personnal-mess">
    <div class="title">个人信息</div>
    <div class="content">
      <div class="left">
        <!-- <div class="demo-upload-list" v-for="item in uploadList"> -->
       
        <Upload
            ref="upload"
            :show-upload-list="false"
            :on-success="handleSuccess"
            :format="['jpg','jpeg','png','gif']"
            :max-size="2048"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :before-upload="handleBeforeUpload"
            :action="imgfileUrl"
            with-credentials
            style="display: inline-block;margin-top:24px">
             <div class="demo-upload">
          
          <!-- <div v-if="uploadList[0]&&uploadList[0].showProgress"> -->
          <div v-if="!failUpload&&uploadList.length>0&&uploadList[0].showProgress">
              <!-- <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress> -->
               <div class="demo-upload-cover">
                  上传中...
              </div>
          </div>
          <div v-if="!failUpload&&imgUrl!==''">
              <!-- <img :src="require(`@/assets/images/app-QRCode.png`)"> -->
              <img style="width:160px;height:160px" :src="imgUrl">
          </div>
          <div v-if="imgUrl==''">
              <img :src="userImgUrl">
              <div style="width:160px;height:160px;color:#c5c8ce">暂无头像</div>
          </div>
          <div v-if="failUpload">
              <!-- <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress> -->
               <div class="demo-upload-cover">
                  上传失败
              </div>
          </div>
        </div>
            <div class="click-change-img">
                点击更换头像
            </div>
        </Upload>
      </div>
      <div class="right">
        <div style="margin-bottom:31px">用户姓名:&#12288;{{userMess.userName}}</div>
        <div style="margin-bottom:24px;display:flex" v-if="outPhone&&isVoiceAgent" :class="inputBorder">
          <div style="margin-right: 4px;padding-top: 3px;">接听方式:&#12288;</div>
          <!-- <div style="display:flex;flex-direction:column"> -->
          <RadioGroup v-model="answerMode" vertical @on-change="changeAnswerMode">
            <Radio label="0" style="margin-bottom:12px">仅系统接听</Radio>
            <Radio label="1" style="margin-bottom:8px;" >
              <span>外部号码接听</span>
              <div v-if="answerMode==1" style="display:inline">
                <Input maxlength="12" v-model.trim="phoneNum" placeholder="请输入手机号" style="width: 300px" @on-change="validatePhoneNume"/>
                <div v-if="answerMode==1" style="font-size:12px;color:red;margin-left: 110px;">{{phoneNumTipContext}}</div>
              </div>
              <span v-if="answerMode==0">{{phoneNum1}}</span>
            </Radio>
          </RadioGroup>
          <!-- </div> -->
        </div>
        <div style="margin-bottom:24px;display:flex" v-if="outPhone&&isVoiceAgent" :class="inputBorder">
          <div v-if="answerMode==1" style="margin-right: 4px;padding-top: 3px;">优先设置:&#12288;
            <Tooltip transfer max-width="700" placement="top">
              <Icon
                style="font-size: 18px;display:block"
                type="md-help-circle"
              />
              <div slot="content">
                <p>设置呼入/呼出效果</p>
                <p>1、 呼入：优先系统接听 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;呼出：系统直接呼出</p>
                <p style="text-indent: 20px">
                  登录系统，有呼入来电，系统接听；退出系统，有呼入来电，外部号码接听；
                </p>
                <p style="text-indent: 20px">
                  呼出时，系统直接呼出，无需转接外部号码；
                </p>
                <p>2、呼入：仅外部号码接听 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;呼出：系统直接呼出</p>
                <p style="text-indent: 20px">
                  无论是否登录系统，有呼入来电，外部号码接听；呼出时，系统直接呼出，无需转接外部号码；
                </p>
                <p>3、呼入：仅外部号码接听 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;呼出：先呼坐席外部号码，再呼客户</p>
                <p style="text-indent: 20px">
                  无论是否登录系统，有呼入来电，外部号码接听；呼出时，先呼转至坐席外部号码，坐席接通后在呼叫客户；
                </p>
              </div>
            </Tooltip>
          </div>
          <div v-if="answerMode==1">
            <RadioGroup
              v-model="youxianType"
              vertical
              style="margin:30px 0 0 -22px"
            >
              <Radio label="6" style="margin-bottom: 8px"
              >呼入：优先系统接听
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;呼出：系统直接呼出</Radio
              >
              <Radio label="5" style="margin-bottom: 8px"
              >呼入：仅外部号码接听
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;呼出：系统直接呼出</Radio
              >
              <Radio label="0" style="margin-bottom: 8px"
              >呼入：仅外部号码接听
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;呼出：先呼坐席外部号码，再呼客户</Radio
              >
            </RadioGroup>
          </div>

        </div>

        <div class="flex-layout">
            <div class="flex-item" v-if="userMess.userIp!==''&&userMess.userIp!==undefined">当前IP:&#12288;{{userMess.userIp}}</div>
            <div class="flex-item" v-if="userMess.agentTelPhone!==''&&userMess.agentTelPhone!==undefined">坐席分机号:&#12288;{{userMess.agentTelPhone}}</div>
            <div class="flex-item" v-if="userMess.userEmail!==''&&userMess.userEmail!==undefined">邮箱:&#12288;{{userMess.userEmail}}</div>
            <div class="flex-item" v-if="agentType!==''&&agentType!==undefined">坐席类型:&#12288;{{agentType}}</div>
         
            <div class="flex-item" v-if="userMess.agentCode!==''&&userMess.agentCode!==undefined">坐席工号:&#12288;{{userMess.agentCode}}</div>
            <div class="flex-item" v-if="userMess.contactPhone!==''&&userMess.contactPhone!==undefined">手机号:&#12288;{{userMess.contactPhone}}</div>
            <div class="flex-item" v-if="userType!==''&&userType!==undefined">用户类型:&#12288;{{userType}}</div>
            <div class="flex-item" v-if="agentPhoneType!==''&&agentPhoneType!==undefined">电话类型:&#12288;{{agentPhoneType}}</div>
          <!-- </div> -->
        </div>

        <div style="display:flex;" v-if="roleData.length>0">
          <div style="margin-right:10px;width:60px">角色:</div>
          <div style="display:flex;flex-wrap:wrap;width: 100%;">
            <div class="skill-list" v-for="item in roleData">
              <div style="background:#EBF5F5;padding:10px;font-weight:700">
                <span style="margin-right:2px">名称:</span>
                <span>{{item.roleName}}</span> 
              </div>
              <!-- <div style="padding:10px;word-wrap:break-word;">
                <span >编码: </span><span style="color:#5E5F77;word-wrap:break-word;">{{item.roleId}}</span>
              </div> -->
            </div>
          </div>
        </div>
        <div style="display:flex;" v-if="roleData.length==0">
          <div style="margin-right:10px;width:60px">角色:</div>
          <div class="skill-list" style="background:#EBF5F5;height:125px;text-align: center;line-height: 125px;">
           暂未分配
          </div>
        </div>

        <div style="display:flex;" v-if="userMess.skills!==undefined&&userMess.skills.length>0">
          <div style="margin-right:10px;width:60px">技能组:</div>
          <div style="display:flex;flex-wrap:wrap;width: 100%;">
            <div class="skill-list" v-for="item in userMess.skills">
              <div style="background:#EBF5F5;padding:10px;font-weight:700">
                <span style="margin-right:2px">名称:</span>
                <span>{{item.skillName}}</span> 
              </div>
              <div style="padding:10px;">
                <span >编码: </span><span style="color:#5E5F77">{{item.skillCode}}</span>
              </div>
              <div style="padding:10px;">
                <span style="margin-right:2px">VDN: </span>
                <span style="color:#5E5F77">{{item.vdn}}</span>
              </div>
            </div>
          </div>
        </div>
        <div style="display:flex;" v-if="(userMess.skills==undefined||userMess.skills.length==0)&&userMess.userType==4">
          <div style="margin-right:10px;width:60px">技能组:</div>
          <div class="skill-list" style="background:#EBF5F5;height:125px;text-align: center;line-height: 125px;">
           暂未分配
          </div>
        </div>
        <Button size="large" style="margin-top:42px"  type="primary" @click="submit" :disabled='submitBtnDisable'>确定</Button>
      </div>
    </div>
  </div>
</template>

<script>
import envConst from '@/env-const'

export default {
  data () {
    return {
      roleData:[],
      defaultOutPhone:'',
      tempPhoneNum:'',
      phoneNumTypeError:false,
      answerMode:'',
      phoneNumTipContext:'',
      phoneNum1:'18339399722',
      phoneNum:"",
      userTypeSign:JSON.parse(localStorage.getItem('user')).info.userType,
      userLogo:'',
      isVoiceAgent:false,
      offlineOnCall:'',
      systemOnCall:true,
      userMess:{},
      failUpload:false,
      baseImageUrl: envConst.API_BASE_URL + '/file/filemanage/downloadFileById/',
      userImgUrl: envConst.SCMCC_HOST + '/images/headshot.svg',
      isEdit:false,
      imgName: '',
      visible: false,
      uploadList: [],
      imgfileUrl:'',
      userType:'',
      agentPhoneType:'',
      agentType:'',
      phoneType:'内置软电话',
      acceptType:'9090',
      selectAcceptType:'',
      acceptTypeList:[
        {
          value:0,
          name:"pc"
        },
        {
          value:1,
          name:"手机182"
        },
        {
          value:2,
          name:"硬话机"
        }
      ],
      userPhoto:'',
      ccType:'',
      outPhone:false,
      youxianType:'0',
      submitBtnDisable:false
    }
  },
  computed: {
    imgUrl() {
      if (this.uploadList[0] && this.uploadList[0].status === 'finished') {
        return this.baseImageUrl + this.uploadList[0].response.bean.attachmentId
      } else if(this.userPhoto=='') {
        return ''
      }else{
         return envConst.API_BASE_URL + this.userPhoto//userPhoto从接口中获取
      }
    },
    inputBorder() {
      if(this.phoneNumTypeError){
        return {inputBorder:true}
      }
    }
  },
  created() {
   let agentType= JSON.parse(localStorage.user).info.agentType;
    this.isVoiceAgent =  agentType=== '1' || agentType=== '4' ||agentType === '6' || agentType === '7';
    this.ccType = JSON.parse(localStorage.getItem("user")).info.ccType;
    //获取头像接口
    this.getUserPhoto();
    this.getMessage();
    let params = {};
    params.userId = JSON.parse(localStorage.user).info.userId;
    this.$http.get("/sctm/user/getuseroutphone",{params}).then(res => {
      if(res.data.returnCode == 0){
        if(res.data.bean.outPhone == 1){//坐席编辑页面外部接听方式开关打开
          this.outPhone = true;
          this.getAgentOutPhoneOrMode()
        }
      }else{
        console.log("查询接听方式失败")
      }
    }).catch(err => {
      console.log("查询接听方式失败")
    })
  },
  mounted() {
   this.uploadList = this.$refs.upload.fileList;
    console.log("created-this.uploadList",this.uploadList)
    this.handClapUuId = this.getUuid()
    this.imgfileUrl = envConst.API_BASE_URL + '/file/filemanage/uploadFile/' +
        this.handClapUuId
  },
  methods: {
    // 外部号码校验
    outPhoneValidate(val) {
      return new Promise((resolve,reject) => {
        if(val === this.defaultOutPhone) {
          resolve({
            returnCode:0
          })
        }else {
          this.$http({
            url:'/sccs/checkAgentOutPhone',
            method:'post',
            data:{
              agentOutPhone:val
            }
          }).then(res => {
            if(res.status === 200) {
              if(res.data.returnCode === 0) {
                resolve(res.data)
              }else {
                this.$Message.error(res.data.returnMessage)
                resolve(res.data)
              }
            }
          }).catch(err => {
            console.log(err)
            this.$Message.error('网络错误！')
          })
        }
        
      })


    },

    getAgentOutPhoneOrMode(){
      let params={};
      params.tenantId = JSON.parse(localStorage.user).info.tenantId;
      params.agentId = JSON.parse(localStorage.user).info.agentId;
       this.$http.post('/sccs/getAgentOutPhoneOrMode',params).then(res => {
         if(res.data.returnCode == 0){
           if(res.data.bean.agentOutPhone == ''|| res.data.bean.agentOutPhone==undefined){
             this.phoneNum1 = JSON.parse(localStorage.user).info.contactPhone;
             this.phoneNum = JSON.parse(localStorage.user).info.contactPhone;
             this.defaultOutPhone = JSON.parse(localStorage.user).info.contactPhone
           }else{
             this.phoneNum1 = res.data.bean.agentOutPhone;
             this.phoneNum = res.data.bean.agentOutPhone;
             this.defaultOutPhone = res.data.bean.agentOutPhone;
             console.log(res.data.bean.connectType);
             this.youxianType = res.data.bean.connectType ? res.data.bean.connectType +'' : '0'
           }
         }
        this.answerMode = res.data.bean.answerMode
       })
    },
    
    validatePhoneNume(fn){
      console.log("112233",this.phoneNum) 
      if(this.phoneNum.length==0){
        this.phoneNumTypeError=true;
        this.phoneNumTipContext="请输入接听号码";
        return
      }
      // let myreg=/^[1][3,4,5,7,8][0-9]{9}$/;
      let myreg= /^\d{1,}$/
      if(!myreg.test(this.phoneNum)){
        console.log("22")
        this.phoneNumTypeError=true;
        this.phoneNumTipContext="请输入正确的手机号码";
        return
      }
      this.outPhoneValidate(this.phoneNum).then(res => {
        if(res.returnCode === 0) {
          this.phoneNumTypeError=false;
          this.phoneNumTipContext="";
          this.phoneNum1 = this.phoneNum;
          if(fn) {fn()}
        }else {
          this.phoneNumTypeError=true;
          this.phoneNumTipContext=res.returnMessage;
        }
        
      })
      
    
    },
    changeAnswerMode(){
      this.phoneNumTypeError=false;
      this.phoneNumTipContext="";
      this.phoneNum=this.phoneNum1
      // if(this.answerMode==1){
      //   this.phoneNum = this.tempPhoneNum
      // }else if(this.answerMode==0){
      //   this.tempPhoneNum = this.phoneNum1
      // }
      console.log("1122",this.answerMode)
      
    },
    submitData() {
      let params = {};
      console.log("22222",this.uploadList)
      if(this.uploadList.length==0){
      if(this.userLogo==undefined||this.userLogo==""){
        params.attachmentId = ''
      }else{
        let arr = this.userLogo.split("/");
        let attachmentIdInit = arr[arr.length-1];
          params.attachmentId = attachmentIdInit.split(".")[0];
      }
      }else{
        params.attachmentId = this.uploadList[0].response.bean.attachmentId;
      }
      // params.attachmentId = this.uploadList.length>0?this.uploadList[0].response.bean.attachmentId:'';
      // console.log("22222",this.uploadList)
      // if((this.userLogo==undefined||this.userLogo=="")){
      //    params.attachmentId = ''
      // }else{
      //   let arr = this.userLogo.split("/");
      //   let attachmentIdInit = arr[arr.length-1];
      //   params.attachmentId = this.uploadList.length>0?this.uploadList[0].response.bean.attachmentId:attachmentIdInit.split(".")[0];
      // }
      
    this.$http.get('/sctm/user/savepersonalcenter',{params}).then(res =>{
        if(res.data.returnCode == 0){
            console.log("个人信息",this.userMess)
          this.$store.commit('main/setAttachmentId', params.attachmentId )
          console.log("个人信息",this.userMess)
          console.log("2222",this.outPhone,this.isVoiceAgent,this.ccType)
          if(!this.outPhone||!this.isVoiceAgent||!this.ccType=='ucp'){
            this.$Message.success('保存成功');
            return
          }
          let params1 = {};
          params1.tenantId = this.userMess.tenantId;
          params1.agentId = this.userMess.agentId;
          params1.answerMode = this.answerMode;
          params1.agentOutPhone = this.phoneNum1;
          params1.agentCode = this.userMess.agentCode;
          params1.ucpTenantCode = this.userMess.ucpTenantCode;
          params1.skillCodes = this.userMess.skills.map(_=>{
            return _.skillCode
          }).join(",");
          console.log("更换接听方式传参",params1)
          this.$http.post('/sccs/addAgentOutPhoneOrMode',params1).then(res => {
            if(res.data.returnCode == 0){
              this.$Message.success('保存成功');
            }else{
              this.$Message.error('保存失败');
            }
          })
        }else{
          this.$Message.error('保存失败');
        }
      }).catch( res => {
        this.$Message.error('保存失败');
      })
    },
    submit(){
      if(this.answerMode==='1') {
        this.validatePhoneNume(() => {
            this.submitData1();
        })
      }else {
          this.submitData1();
      }
    },
    submitData1(){
      this.submitBtnDisable=true;
      let params = {};
      params.tenantId = this.userMess.tenantId;
      params.agentId = this.userMess.agentId;
      params.answerMode = this.answerMode;
      params.agentOutPhone = this.phoneNum1;
      params.agentCode = this.userMess.agentCode;
      params.ucpTenantCode = this.userMess.ucpTenantCode;
      params.skillCodes = this.userMess.skills.map(_=>{
        return _.skillCode
      }).join(",");
      params.connectType = this.youxianType
      this.$http
        .post("/sccs/answerConfigure/saveAgentPhone", params)
        .then((res) => {
        this.submitBtnDisable=false;
          if (res.data.returnCode == 0) {
            this.$Message.success("保存成功");
            this.show = false
          }
        })
      .catch((e)=>{
        this.$Message.error("保存失败");
        this.submitBtnDisable=false;
      });
    },
    //获取右侧相关信息
    getMessage(){
      this.$http.get('/sctm/user/getpersonalcenter').then(res =>{
        if(res.data.returnCode == 0){
          console.log("pp")
          this.userMess = res.data.bean;
          this.userLogo = res.data.bean.userLogo;
          let userTypeList = [
            {
              value:"1",
              name:"高级管理员"
            },
            {
              value:"2",
              name:"租户管理员"
            },
            {
              value:"3",
              name:"普通管理员"
            },
            {
              value:"4",
              name:"客服人员"
            },
            {
              value:"5",
              name:"质检人员"
            },
            {
              value:"6",
              name:"业务人员"
            },
          ];
          let agentPhoneTypeList = [
            {
              value:"1",
              name:"内置软电话"
            },
           {
              value:"2",
              name:"外置软电话"
            },
            {
              value:"3",
              name:"webrtc"
            },
            {
              value:"4",//加上融合内置软电话
              name:"融合内置软电话"
            },
          ];
          let agentTypeList = [
             {
              value:"1",
              name:"语音坐席"
            },
           {
              value:"2",
              name:"IM坐席"
            },
            {
              value:"3",
              name:"视频坐席"
            },
            {
              value:"4",
              name:"融合坐席"
            },
          ];
          if(this.userMess.userType!==""&& this.userMess.userType!==undefined){
             this.userType=userTypeList.find(item => item.value == this.userMess.userType).name;
          }
          if(this.userMess.agentType!==""&& this.userMess.agentType!==undefined){
            this.agentType= agentTypeList.find(item => item.value == this.userMess.agentType).name;
          }
          if(this.userMess.agentPhoneType!==""&& this.userMess.agentPhoneType!==undefined){
            this.agentPhoneType=agentPhoneTypeList.find(item => item.value == this.userMess.agentPhoneType).name;
          }
          this.$http.get('/sctm/userprivilages/userrole').then(res => {
            this.roleData = res.data.beans
            // let rolesAll = []//全部的角色
            // let roleTrue = JSON.parse(window.localStorage.user).info.roleIds.split(',')//当前用户的角色
            // let roleData = []//供展示的角色数据
            //   if (res.data.returnCode == 0) {
            //       rolesAll = res.data.beans
            //       // let list = arr.filter(_ => _.lightContent.indexOf(this.keyWords) > 0);
                
            //       roleTrue.map(v=>{
            //         rolesAll.filter((item)=>{
            //           if(item.roleId == v){
            //             roleData.push(item)
            //           }
            //         })
            //       })
            //   }
          })
        }else{
          this.$Message.error('个人信息查询失败');
        }
      }).catch((err) => {
        // console.log(err)
        //  this.$Message.error('个人信息查询失败');
      })
    },
    
    getUserPhoto(){
      //调接口获取用户头像地址,拿到this.userPhoto
      this.$http.get('/sctm/user/getuserimg').then(res =>{
        if(res.data.returnCode == 0){
          this.userPhoto = res.data.bean
        }else{
          this.$Message.error('头像地址查询失败');
        }
      }).catch( res => {
         this.$Message.error('头像地址查询失败');
      })
    },
     //生成uuid
    uuIdPre() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    },
    //生成随机数
    getUuid() {
      return (
        this.uuIdPre() +
        this.uuIdPre() +
        this.uuIdPre() +
        this.uuIdPre() +
        this.uuIdPre() +
        this.uuIdPre() +
        this.uuIdPre() +
        this.uuIdPre()
      )
    },
    handleView (name) {
              this.imgName = name;
              this.visible = true;
          },
    handleRemove (file) {
        const fileList = this.$refs.upload.fileList;
        this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
    },
    handleSuccess (res, file,fileList) {
      console.log("1106success",res, file,fileList)
      if(res.returnCode == 0){
         this.failUpload = false
         console.log("1106success-this.uploadList",this.uploadList)
        const check = this.uploadList.length > 1;
        if (check) {
            this.uploadList.splice(0,this.uploadList.length-1)
        }
        console.log("1106success-this.uploadList11",this.uploadList)
      }else{
        this.failUpload = true
      }
     
    },
    handleFormatError (file) {
        this.$Message.warning("请上传jpg/jpeg/png/gif/格式的图片");
    },
    handleMaxSize (file) {
       this.$Message.warning("图片大小不能超过2M");
       this.failUpload = true;
    },
    handleBeforeUpload (data) {
      console.log("1106before",data)
       console.log("1106before",this.uploadList)
      //  console.log("11",this.uploadList[0].showProgress)
       
        const check = this.uploadList.length > 1;
        if (check) {
            // this.$Notice.warning({
            //     title: 'Up to five pictures can be uploaded.'
            // });
            this.uploadList.splice(0,this.uploadList.length-1)
        }
        // return check;
    },
    submitSelectAcceptType(){
      console.log("1106确认选择")
      this.isEdit = false;
    },
    cancelSelectAcceptType(){
      console.log("1106取消选择")
      this.isEdit = false;
    },
    editAcceptType(){
      this.isEdit = true;
    }
  }
}

</script>

<style lang='less'>
 
.personnal-mess{
  background: #fff;
  border-radius: 4px;
  padding: 24px;
  width:100%;
  height:100%;
  .title{
    font-size:18px;
    line-height: 1;
    padding-left: 9px;
    margin-bottom: 48px;
    border-left-width: 4px;
    border-left-style: solid;
    border-color: #04cbd8
  }
  .content{
    display: flex;
    // align-items:center;
    .left{
      margin-top: 96px;
      padding-left: 76px;
      padding-right: 76px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .demo-upload{
        display: inline-block;
        width: 160px;
        height: 160px;
        text-align: center;
        line-height: 160px;
        border: 1px solid#F0F4F4;
        border-radius: 80px;
        overflow: hidden;
        background: #fff;
      }
      .demo-upload-cover{
          display: block;
          position: block;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          color:#FFFFFF;
          background: rgba(0,0,0,.5);
      }
      .demo-upload:hover .demo-upload-cover{
          display: block;
      }
      .demo-upload-cover i{
          color: #fff;
          font-size: 20px;
          cursor: pointer;
          margin: 0 2px;
      }
      .click-change-img{
        cursor:pointer;
        color:#33344A;
        font-size:14px;
        margin-top:27px;
        text-align: center;
      }
      //  .click-change-img:hover{
      //   cursor:pointer;
      //   color:#56e5ef;
      //   font-size:14px
      // }
      //  .click-change-img:visited{
      //   cursor:pointer;
      //   color:#33344A;
      //   font-size:14px
      // }
    }
    .right{
      color: #33344A;
      font-size:14px;
      padding:32px;
      border-left-width: 2px;
      border-left-style: solid;
      border-color:#F7F9F9;
      .inputBorder{
        .ivu-input {
          border: 1px solid red;
        }
      }
     .flex-layout{
       display:flex;
       flex-wrap: wrap;
       .flex-item{
         margin-bottom:24px;
         width:50%;
       }
     }
     .skill-list{
       margin-right:3%;
       border:1px solid #F7F9F9;
       width:30%;
       margin-bottom:10px
     }
    }
  }
}
    
</style>
